








import { Component, Vue } from 'vue-property-decorator';
import AlertMessage from '@/components/AlertMessage.vue';
import Loading from '@/components/Loading.vue';

@Component ({
	components: { AlertMessage, Loading }
})
export default class App extends Vue
{
}

